import { Injectable } from '@angular/core';
import { ConstantsService } from './constants.service';

@Injectable()
export class SizeHelperService {

  constructor(private constants: ConstantsService) { }

  decimalOnly = /^[0-9]\d*(\.\d{1,2})?\s*$/;
  regularFTandINCH = /^[0-9]\d*(\.\d{1,2})?\s*\'\s*?[0-9]\d*(\.\d{1,2})?\s*"\s*$/; //format example: 1.45'1.65"
  regularFT = /^[0-9]\d*(\.\d{1,2})?\s*'\s*$/; //format example: 1.45'
  regularINCH = /^(?:\s*(\d+)\/)?(?:(\d+)\s*(\.\d{1,2})?(?:in|''|")?)?$/; //format example: 1.65"
  meters = /^[0-9]\d*(\.\d{1,2})?\s*?m$/; // 10m / 10.10m / 10 m / 10.1 m
  centimeters = /^[0-9]\d*(\.\d{1,2})?(\s*)?(cm)?$/;// 10cm / 10.10cm / 10 cm / 10.1 cm / 10 / 10.1
  CMandMeter = /^[0-9]\d*(\.\d{1,2})?\s*?m\s*[0-9]\d*(\.\d{1,2})?(\s*)?(cm)?$/;
  checkCM = /^[0-9]\d*(\.\d{1,2})?\s*?cm$/;
  checkFT = /^(?:\s*(\d+)\/)?(?:(\d+)\s*(\.\d{1,2})?(?:in|''|'))?$/;
  checkMeters = /^[0-9]\d*(\.\d{1,2})+(\s*)?(m)\s*?[0-9]\d*(\.\d{1,2})?(\s*)?(cm)?$/;
  checkFTn = /^[0-9]\d*(\.\d{1,2})+(\s*)?(")\s*?[0-9]\d*(\.\d{1,2})?(\s*)?(')?$/;
  checkNum = /^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$/;

  parseSize(units, str) {
    var FT, INCH, CM, delims, parser, meters, sizes: any;
    switch (units) {
      case this.constants.SizeUnit.FT_INCH:
        {
          delims = "'";
          parser = str.split(delims);
          FT = parser[0];
          str = parser[1];
          delims = '"';
          parser = str.split(delims);
          INCH = parser[0];
          sizes = { ft: parseFloat(FT), inch: parseFloat(INCH) };
        }
        break;

      case this.constants.SizeUnit.FT:
        {
          delims = "'";
          parser = str.split(delims);
          FT = parser[0];
          sizes = { ft: parseFloat(FT) };


        }
        break;

      case this.constants.SizeUnit.INCH:
        {
          delims = '"';
          parser = str.split(delims);
          INCH = parser[0];
          sizes = { inch: parseFloat(INCH) };


        }
        break;

      default: {
        sizes = {};

      }
        break;

    }
    return sizes;
  };

  polygonArea(X, Y, numPoints) {
    var area = 0,
      j = numPoints - 1,  // The last vertex is the 'previous' one to the first
      i = 0;
    for (; i < numPoints; i++) {
      area += (X[j] + X[i]) * (Y[j] - Y[i]);
      j = i;  //j is previous vertex to i
    }
    return Math.abs(area / 2);
  };

  toCM(sizeText, appSizeUnits) {
    var units = this.detectSizeUnits(sizeText, appSizeUnits),
      res = this.parseSize(units, sizeText),
      ftToCm = 0,
      inToCm = 0,
      CM = 0;

    if (res.ft)
      ftToCm = res.ft * 30.48;

    if (res.inch)
      inToCm = this.INCHToCM(res.inch);

    if (res.cm)
      CM = res.cm;

    return parseFloat((ftToCm + inToCm + CM).toFixed(2));
  }

  CMToFTAndINCH(length) {

    var convert = length * 0.3937008;
    var FT = convert / 12;
    FT = Math.floor(FT);
    var dif = convert / 12 - FT;
    var INCH = dif / (1 / 12);
    INCH = parseFloat(INCH.toFixed(1));
    if (INCH === 12) {
      FT += 1;
      INCH = 0;
    }

    var result = FT + "'" + INCH + '"';

    return result;
  }

  CMToFTAndINCHToEdge(length) {

    var convert = length * 0.3937008;
    var FT = convert / 12;
    FT = Math.floor(FT);
    var dif = convert / 12 - FT;
    var INCH = dif / (1 / 12);
    INCH = parseFloat(INCH.toFixed(0));
    if (INCH === 12) {
      FT += 1;
      INCH = 0;
    }

    var result = FT + "'" + INCH + '"';

    return result;
  }

  CMToMAndCM (value: number): string {
    value = Math.round(value * 4) / 4;
    let m = Math.floor(value / 100);
    let cm = Math.floor(value % 100);
    return `${m}m ${cm}cm`;
  }

  CMToMM(value: number): string {
    value = Math.round(value * 4) / 4;
    value *= 10;
    return `${value}`;
  }

  CMToFT(cm) {
    return parseFloat(cm) * 0.032808399;
  }

  CMToINCH(cm) {
    return (cm * 0.3937007874);
  }

  MToFeet(m) {
    return m * 3.2808399;
  }

  INCHToCM(inch) {
    return inch * 2.54;
  }

  INCHToFT(inch) {
    return inch * 0.0833333;
  }

  convertM2ToFT2(v) {
    var res:any = parseFloat((v * 10.764).toFixed(2));
    var d = res.toString().split(".")[1];
    if ((parseFloat('0.' + d)) < 0.1) {
      res = res.toString().split(".")[0] + '.00'
    }
    return res;
  }

  getFloorArea(points) {
    var X = [],
      Y = [],
      i = 0,
      point,
      numPoints = points.length,
      area;

    for (; i < numPoints; i++) {
      point = points[i];
      X.push(point.x);
      Y.push(point.y);
    }

    area = this.polygonArea(X, Y, numPoints);
    area = area * 0.0001; // convert cm2 to m2

    return area;
  }

  detectSizeUnits(value, units) {
    var result = null;
    if (units === this.constants.SizeUnit.FT) {
      if (this.regularINCH.test(value))
        result = this.constants.SizeUnit.INCH;
      else if (this.regularFT.test(value))
        result = this.constants.SizeUnit.FT;
      else if (this.regularFTandINCH.test(value))
        result = this.constants.SizeUnit.FT_INCH;
    }
    else if (this.meters.test(value)) {
      result = this.constants.SizeUnit.M;
    }
    else if (this.centimeters.test(value)) {
      result = this.constants.SizeUnit.CM;
    }
    else if (this.decimalOnly.test(value)) {
      result = this.constants.SizeUnit.CM;
    }
    else if (this.CMandMeter.test(value)) {
      result = this.constants.SizeUnit.CM_METER;
    }

    return result;
  }

  checkSizeFormat(value) {
    var size = value;
    if (size >= 196.8 && size <= 400) {
      return true;
    }
    return false;
  }

  checkIfEmpty(value) {
    if (!value || (value && (value.replace(/\s/g, '') == ''))) {
      return true;
    }
    return false;
  }

  checkNumerical(value) {
    if (this.checkNum.test(value) || this.checkIfEmpty(value)) {
      return true;
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/size-helper.service.ts